import { createAsyncThunk } from '@reduxjs/toolkit';
import { fixText } from '../api/chatGptApi'; // Ruta a API
import { endLoading, startLoading } from '../slices/loadingSlice';
import { handleError } from '../slices/errorsSlice';

export const fixTextThunk = createAsyncThunk(
  'corrections/fixText',
  async ({ originalText }, { getState, dispatch }) => {
    const { token } = getState().auth;

    dispatch(startLoading());

    try {
      
      const response = await fixText(token, originalText);
      return response.json();

    } catch (error) {
      dispatch(handleError(error));
      throw error;
    } finally {
      dispatch(endLoading());
    }
  }
);
